import React, { useState } from 'react'
import { Button } from '../../common/Form';
import { generateCompletedOrderPDF, generateCompletedOrderBatchPDF, generatePrintedCompletedOrderBatchPDF, getBookletNameQuery } from '../../queries/booklet';
import { useMutation, useQuery } from '@apollo/client';

const OrderBatchDownloadPDF = ({ bookletId, batchLabel, orderId, orderCode, isEmailView }) => {
  const [generateBatchPDF, { loading: isPdfBatchMutationLoading, error: batchError }] = useMutation(generateCompletedOrderBatchPDF);
  const [generatePrintedBatchPDF, { loading: isPrintedPdfBatchMutationLoading, error: printedBatchError }] = useMutation(generatePrintedCompletedOrderBatchPDF);
  const [generateOrderPDF, { loading: isOrderPdfMutationLoading, error: orderError }] = useMutation(generateCompletedOrderPDF);
  const [loading, setLoading] = useState('');

  const { data: bookletData } = useQuery(getBookletNameQuery, {
    variables: { _id: bookletId },
    skip: !bookletId
  });

  const downloadAsPDF = async (mode, isPrinted = false) => {
    if (isPdfBatchMutationLoading || isOrderPdfMutationLoading || isPrintedPdfBatchMutationLoading) return;

    setLoading(mode);
    try {
      let base64Data;

      if (mode === 'single') {
        const response = await generateOrderPDF({
          variables: {
            bookletId,
            orderId,
            encryptedOrderCode: orderCode,
          }
        });
        base64Data = response.data.generateCompletedOrderPDF;
      } else {
        const response = await (isPrinted ? generatePrintedBatchPDF : generateBatchPDF)({
          variables: {
            batchLabel,
            bookletId,
            mode: mode === 'printed-combined' ? 'combined' : mode
          }
        });
        base64Data = isPrinted
          ? response.data.generatePrintedCompletedOrderBatchPDF
          : response.data.generateCompletedOrderBatchPDF;
      }

      let blob;
      const fileName = `Värdebevis - ${bookletData?.booklet?.title || ''}${isPrinted ? ' - Utskrivningsformat' : ''}.${mode === 'separated' ? 'zip' : 'pdf'}`;

      // Convert base64 to binary data
      const binaryString = window.atob(base64Data);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create appropriate blob based on file type
      blob = new Blob([bytes], {
        type: mode === 'separated' ? 'application/zip' : 'application/pdf'
      });

      // Create and download file
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);

      setLoading('');
    } catch (err) {
      console.error('Error generating PDF:', err);
      setLoading('');
    }
  };


  const currentError = batchError || orderError || printedBatchError;

  return (
    <div>
      <div className={`flex flex-col max-w mb ${isEmailView ? 'gap-1' : ''}`}>
        {orderId ? (
          <Button
            type='button'
            onClick={() => downloadAsPDF('single')}
            className="primary md"
            disabled={loading === 'single'}
          >
            {loading === 'single' ? 'Laddar... (ca 15 sek)' : 'Ladda ned PDF'}
          </Button>
        ) : (
          <>
            <Button type='button' onClick={() => downloadAsPDF('printed-combined', true)} className="primary md" disabled={loading === 'printed-combined' || loading === 'printed-separated' || loading === 'combined' || loading === 'separated'}>
              {loading === 'printed-combined' ? 'Laddar... (ca 15 sek)' : 'Kombinerad PDF - Tryckta värdebevis'}
            </Button>
            <Button type='button' onClick={() => downloadAsPDF('combined')} className="primary md" disabled={loading === 'combined' || loading === 'separated' || loading === 'printed-combined' || loading === 'printed-separated'}>
              {loading === 'combined' ? 'Laddar... (ca 15 sek)' : 'Kombinerad PDF - A4'}
            </Button>
            <Button type='button' onClick={() => downloadAsPDF('separated')} className="primary md" disabled={loading === 'separated' || loading === 'combined' || loading === 'printed-combined' || loading === 'printed-separated'}>
              {loading === 'separated' ? 'Laddar... (1 - 10 min)' : 'Separata PDF:er - A4 (1 - 10min)'}
            </Button>
          </>
        )}
        {currentError && (
          <p className="error">
            {currentError.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default OrderBatchDownloadPDF
